// Mock data for Dublin Holistic Massage Website

export const businessInfo = {
  name: "Dublin Holistic Massage",
  tagline: "Professional Therapeutic Massage by Qualified & Experienced Therapists",
  phone: "+353 85 774 7474",
  email: "dublinholisticmassage@gmail.com",
  whatsapp: "+353857747474",
  hours: "Mon to Sun: 9AM - 9PM",
  experience: "14+ years",
  squareBookingUrl: "https://dublin-holistic-massage.square.site/",
  clarehallBookingUrl: "https://couplesmassagedublin.com/",
  tiktokUrl: "https://www.tiktok.com/@dublin.holistic.m",
  tripadvisorUrl: "https://www.tripadvisor.com/Attraction_Review-g186605-d7610732-Reviews-Dublin_Holistic_Massage-Dublin_County_Dublin.html",
  instagramUrl: "https://www.instagram.com/dublinholisticmassage/",
  instagramStudioVideo: "https://www.instagram.com/reel/C0YgoOmM0ak/",
  tiktokTestimonialVideo: "https://vm.tiktok.com/ZNRhtAPXe/"
};

export const locations = [
  {
    id: 1,
    name: "City Centre",
    area: "Dublin 1",
    address: "19 Talbot Street, Dublin, D01X9P9",
    landmark: "Opposite The Celt Pub",
    features: ["Near Connolly Train Station", "Close to Busáras", "Opposite The Celt Pub"],
    parking: false,
    shower: false,
    nearbyParking: ["Irish Life Car Park", "Q-Park"],
    bookingUrl: "https://dublin-holistic-massage.square.site/",
    mapUrl: "https://maps.app.goo.gl/CtoHeUEkZoiLxUhR7",
    embedMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d595.4!2d-6.2533!3d53.3508!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e8469a4f16b%3A0x8b0c8e8c0b8f2d4e!2sDublin%20Holistic%20Massage!5e0!3m2!1sen!2sie!4v1700000000000!5m2!1sen!2sie"
  },
  {
    id: 2,
    name: "Clarehall",
    area: "Dublin 17",
    address: "Clare Village Apartments, Donaghmede, Dublin, D17 YO12",
    landmark: "Near Clare Grove Icehouse",
    features: ["Free Dedicated Car Parking", "Shower Facilities", "Near Clarehall Shopping Centre"],
    parking: true,
    shower: true,
    nearbyParking: [],
    bookingUrl: "https://couplesmassagedublin.com/",
    mapUrl: "https://maps.app.goo.gl/w1WnPuvjFWK56Pn79",
    embedMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1190!2d-6.1480!3d53.3980!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670f55c6e8b1a3%3A0x2c1d4e5f6a7b8c9d!2sClare%20Village%20Apartments!5e0!3m2!1sen!2sie!4v1700000000000!5m2!1sen!2sie"
  }
];

export const services = [
  {
    id: 100,
    name: "90min Couples Massage 💕",
    description: "Romantic 90-minute massage experience for two - perfect for Valentine's Day! Enjoy side-by-side relaxation with your partner",
    duration: "1 hr 30 mins",
    price: 150,
    category: "couples",
    isPopular: true,
    badge: "Valentine's Special"
  },
  {
    id: 101,
    name: "60min Couples Massage 💑",
    description: "Share a relaxing massage experience with your partner - ideal for a romantic treat or special celebration (price per person)",
    duration: "1 hour",
    price: 120,
    category: "couples",
    note: "€120 per person"
  },
  {
    id: 1,
    name: "30min Massage",
    description: "Quick relief session - Deep Tissue or Relaxing massage to target specific areas",
    duration: "30 mins",
    price: 80,
    category: "express"
  },
  {
    id: 2,
    name: "45min Deep Tissue",
    description: "Focused deep tissue work to release muscle tension and knots",
    duration: "45 mins",
    price: 100,
    category: "deep-tissue"
  },
  {
    id: 3,
    name: "45min Relaxing",
    description: "Calming relaxation massage to ease stress and promote wellbeing",
    duration: "45 mins",
    price: 100,
    category: "relaxing"
  },
  {
    id: 4,
    name: "60min Deep Tissue",
    description: "Full body deep tissue massage targeting muscle tension and chronic pain",
    duration: "1 hour",
    price: 120,
    category: "deep-tissue"
  },
  {
    id: 5,
    name: "60min Relaxing",
    description: "Full body relaxation massage for complete stress relief",
    duration: "1 hour",
    price: 120,
    category: "relaxing"
  },
  {
    id: 6,
    name: "90min Deep Tissue",
    description: "Extended deep tissue session for thorough muscle work and recovery",
    duration: "1 hr 30 mins",
    price: 150,
    category: "deep-tissue"
  },
  {
    id: 7,
    name: "90min Relaxing",
    description: "Extended relaxation session for deep stress relief and rejuvenation",
    duration: "1 hr 30 mins",
    price: 150,
    category: "relaxing"
  },
  {
    id: 8,
    name: "2hr Deep Tissue",
    description: "Comprehensive deep tissue therapy for full body recovery",
    duration: "2 hours",
    price: 240,
    category: "deep-tissue"
  },
  {
    id: 9,
    name: "2hr Relaxing",
    description: "Ultimate relaxation experience for complete mind and body renewal",
    duration: "2 hours",
    price: 240,
    category: "relaxing"
  },
  {
    id: 10,
    name: "Senior Male Therapist - 1hr",
    description: "Massage session with experienced senior male therapist",
    duration: "1 hour",
    price: 120,
    category: "premium"
  },
  {
    id: 11,
    name: "Senior Male Therapist - 90min",
    description: "Extended session with experienced senior male therapist",
    duration: "1 hr 30 mins",
    price: 150,
    category: "premium"
  },
  {
    id: 12,
    name: "Senior Male Therapist - 2hr",
    description: "Premium full session with experienced senior male therapist",
    duration: "2 hours",
    price: 240,
    category: "premium"
  },
  {
    id: 13,
    name: "Senior Female Therapist - 1hr",
    description: "Session with experienced senior female therapist - Unique technique combining Lomi Lomi, Deep Tissue & Swedish",
    duration: "1 hour",
    price: 120,
    category: "premium"
  },
  {
    id: 14,
    name: "Senior Female Therapist - 90min",
    description: "Extended session with senior female therapist - Reflexology, Relaxing or Deep Tissue",
    duration: "1 hr 30 mins",
    price: 150,
    category: "premium"
  },
  {
    id: 15,
    name: "Senior Female Therapist - 2hr",
    description: "Premium full session with senior female therapist",
    duration: "2 hours",
    price: 240,
    category: "premium"
  },
  {
    id: 16,
    name: "30min Reflexology",
    description: "Targeted foot reflexology to stimulate the body's natural healing",
    duration: "30 mins",
    price: 80,
    category: "reflexology"
  },
  {
    id: 17,
    name: "60min Reflexology",
    description: "Full reflexology session by NRRI-registered therapists",
    duration: "1 hour",
    price: 120,
    category: "reflexology"
  },
  {
    id: 18,
    name: "90min Reflexology",
    description: "Extended reflexology treatment for deep restoration",
    duration: "1 hr 30 mins",
    price: 160,
    category: "reflexology"
  }
];

export const team = [
  {
    id: 1,
    name: "Dr. Michael Omakobia",
    role: "Lead Therapist & Masters Athlete",
    credentials: "PhD in Medical and Healthcare Studies",
    bio: "Dr. Michael Omakobia brings expertise in medical and therapeutic practices. Holding a PhD in Medical and Healthcare Studies, he blends scientific knowledge with hands-on massage therapy. As an experienced Masters Athlete competing in the M40 category with Clonliffe Harriers AC - winning the 200m at the Athletics Ireland National Masters Indoor Championships - he has first-hand understanding of athletic recovery. Runners typically have tight calves and IT bands, and Dr. Michael knows exactly how to release this tightness. Specializing in deep tissue, Thai, and Lomi Lomi techniques, he tailors treatments to each client's needs. His approach promotes healing, relieves tension, and enhances overall well-being.",
    specialties: ["Deep Tissue", "Sports Massage", "Thai Massage", "Lomi Lomi", "Athletic Recovery"],
    image: "https://customer-assets.emergentagent.com/job_905f2ba3-e3d2-46ba-8c1f-ae54c31b9b64/artifacts/c0i7hb50_20251128_115503.jpg"
  },
  {
    id: 2,
    name: "Ana",
    role: "Senior Massage Therapist",
    credentials: "10+ Years Experience",
    bio: "Ana is a qualified and experienced Senior Massage Therapist with over 10 years of massage experience. She uses her unique massage technique based on Lomi Lomi, Deep Tissue, Shiatsu, Thai, Sports and Swedish Massage to provide a truly personalized therapeutic experience.",
    specialties: ["Lomi Lomi", "Deep Tissue", "Shiatsu", "Swedish", "Reflexology"],
    image: "https://customer-assets.emergentagent.com/job_905f2ba3-e3d2-46ba-8c1f-ae54c31b9b64/artifacts/a2rw88g0_Screenshot_20260113_221311_Instagram.jpg",
    video: "https://customer-assets.emergentagent.com/job_massage-sanctuary/artifacts/6cjmff19_XiaoYing_Video_1769536117913.mp4"
  },
  {
    id: 3,
    name: "Buggie",
    role: "Deep Tissue & Asian Massage Specialist",
    credentials: "Expert in Shiatsu, Thai & Gua Sha Techniques",
    bio: "Buggie is one of our most talented deep tissue masseuses with exceptional expertise in Shiatsu, Thai massage, and traditional healing techniques. She specializes in Thai Yoga Massage with stretching to improve flexibility and release tension, targeted head and neck massage for stress relief, and Gua Sha massage - an ancient Chinese healing technique that promotes circulation and relieves muscle pain. Her skilled hands and intuitive understanding of the body's pressure points allow her to deliver powerful therapeutic treatments that leave clients feeling completely renewed.",
    specialties: ["Deep Tissue", "Shiatsu", "Thai Massage", "Thai Yoga with Stretching", "Head & Neck Massage", "Gua Sha"],
    image: "https://static.prod-images.emergentagent.com/jobs/4d2f52c7-22cd-4150-9059-ad99d56ca7fb/images/2a2dde51ef093902321b2cd395ef519878ab8ec4aa4bb42041544680255eb1cc.jpeg",
    imagePosition: "center",
    video: "https://customer-assets.emergentagent.com/job_massage-sanctuary/artifacts/owxn7pzc_VID-20260125-WA0007.mp4"
  },
  {
    id: 4,
    name: "Leslie",
    role: "Senior Relaxing Massage Specialist",
    credentials: "Wellness & Relaxation Expert",
    bio: "Leslie is our wonderful relaxing massage specialist with a warm, caring touch and a natural gift for putting clients instantly at ease. Her gentle, flowing techniques melt away stress and tension, leaving you in a state of complete tranquility.",
    specialties: ["Relaxing Massage", "Swedish Massage", "Deep Tissue", "Stress Relief", "Wellness Therapy"],
    image: "https://static.prod-images.emergentagent.com/jobs/4d2f52c7-22cd-4150-9059-ad99d56ca7fb/images/6ee6b03adebc10c2697f50e53e6b912b6d900ba9135e9a05b428dc2a75f8a5dd.jpeg",
    imagePosition: "crop-top",
    video: "https://customer-assets-gfyr7b9c.emergentagent.net/job_4d2f52c7-22cd-4150-9059-ad99d56ca7fb/artifacts/btq5zuyn_XiaoYing_Video_1790867839342_HD.mp4"
  },
  {
    id: 5,
    name: "Lana",
    role: "Massage Therapist",
    credentials: "Swedish & Relaxation Specialist",
    bio: "Lana is a skilled massage therapist specializing in Swedish and relaxing massage therapies. Her gentle yet effective techniques focus on promoting deep relaxation, reducing stress, and improving overall well-being. With her calming presence and intuitive touch, Lana creates a peaceful sanctuary for clients seeking to unwind and restore balance to their body and mind.",
    specialties: ["Swedish Massage", "Relaxing Massage", "Stress Relief", "Wellness Therapy"],
    image: "https://customer-assets.emergentagent.com/job_massage-therapy-19/artifacts/jgespj5n_Screenshot_20260122_103240_WhatsApp.jpg"
  },
  {
    id: 6,
    name: "Victor",
    role: "Senior Deep Tissue & Relaxing Massage Therapist",
    credentials: "Specialist in Deep Tissue & Relaxation",
    bio: "Victor is an excellent senior massage therapist with a remarkable ability to seamlessly blend deep tissue and relaxing massage techniques. His strong, precise hands work expertly to release deep-seated muscle tension while maintaining a soothing, calming flow throughout the session. Whether you need targeted relief from chronic pain or a deeply relaxing escape from everyday stress, Victor adapts his approach to deliver exactly what your body needs. Clients consistently praise his intuitive touch and the lasting relief his treatments provide.",
    specialties: ["Deep Tissue", "Relaxing Massage", "Sports Recovery", "Swedish Massage", "Therapeutic Massage"],
    image: "https://images.unsplash.com/photo-1650044252595-cacd425982ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxtYWxlJTIwbWFzc2FnZSUyMHRoZXJhcGlzdCUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc3Mjk3ODg0NXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 9,
    name: "Rino",
    role: "Senior Massage Therapist",
    credentials: "20+ Years International Experience | Certified Thai Massage Professional",
    bio: "Rino is a senior massage therapist with over 20 years of international experience in top spas and hotels across Italy, London, Dubai and Ireland. A government-certified Thai Massage professional and qualified sports scientist, he expertly combines Sports & Deep Tissue, Thai, Shiatsu and Hot Stone techniques. His holistic approach is shaped by his background as a yoga teacher and personal trainer, tailoring every treatment to your body's needs. Rino speaks English, Italian, Spanish and French.",
    specialties: ["Deep Tissue", "Sports Massage", "Thai Massage", "Shiatsu", "Hot Stone"],
    image: "https://customer-assets.emergentagent.com/job_4d2f52c7-22cd-4150-9059-ad99d56ca7fb/artifacts/u5qabor3_IMG-20260713-WA0002.jpg"
  },
  {
    id: 10,
    name: "Salome",
    role: "Relaxing Massage Therapist",
    credentials: "Wellness, Relaxation & Personalized Care",
    bio: "Salome is a professional massage therapist dedicated to helping each client improve their physical and mental well-being through massage techniques tailored to their individual needs. Warm and attentive, she creates a safe, comfortable space where you can truly disconnect from daily stress and restore your body's natural balance - with every treatment personalised to how you feel that day.",
    specialties: ["Relaxing Massage", "Swedish Massage", "Personalized Care", "Stress Relief", "Wellness Therapy"],
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_4d2f52c7-22cd-4150-9059-ad99d56ca7fb/artifacts/crulhcud_IMG-20260809-WA0008.webp",
    imagePosition: "center"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Barry L.",
    rating: 5,
    text: "Fantastic service! Cyrus has an amazing ability to eliminate knots. Left feeling so much more mobile. Highly recommend!",
    service: "Deep Tissue Massage",
    date: "September 2025",
    source: "TripAdvisor"
  },
  {
    id: 2,
    name: "Natalia",
    rating: 5,
    text: "I've been a client since 2022. Nice place to relax with friendly therapists and unique massage styles. Great price-quality ratio and you can get insurance rebates too!",
    service: "Regular Client",
    date: "February 2025",
    source: "TripAdvisor"
  },
  {
    id: 3,
    name: "Emma K.",
    rating: 5,
    text: "The Clarehall location is perfect - free parking and shower facilities. The massage itself was heavenly. Will definitely be back!",
    service: "Relaxing Massage",
    date: "2025",
    source: "TripAdvisor"
  },
  {
    id: 4,
    name: "Patrick D.",
    rating: 5,
    text: "Top-notch service with friendly staff and a calming atmosphere. You can feel the genuine care they put into every session. Best massage in Dublin!",
    service: "Deep Tissue Massage",
    date: "October 2025",
    source: "TripAdvisor"
  }
];

export const healthInsurance = {
  description: "We are registered with Irish Massage Therapists Association and National Register of Reflexologists Ireland. Our services may be covered by your private health insurance.",
  providers: [
    { name: "Irish Life Health", covered: true, logo: "https://customer-assets.emergentagent.com/job_905f2ba3-e3d2-46ba-8c1f-ae54c31b9b64/artifacts/scivnsl7_20260113_220258.jpg" },
    { name: "Laya Healthcare", covered: true, logo: "https://customer-assets.emergentagent.com/job_905f2ba3-e3d2-46ba-8c1f-ae54c31b9b64/artifacts/9h4fvoyp_20260113_220307.jpg" },
    { name: "VHI Healthcare", covered: true, logo: "https://customer-assets.emergentagent.com/job_905f2ba3-e3d2-46ba-8c1f-ae54c31b9b64/artifacts/axpnsgeq_20260113_220246.jpg" },
    { name: "Level", covered: true, logo: "https://customer-assets.emergentagent.com/job_905f2ba3-e3d2-46ba-8c1f-ae54c31b9b64/artifacts/1n9a8vq6_20260113_220310.jpg" },
    { name: "Westfield Health", covered: true, logo: "https://customer-assets.emergentagent.com/job_905f2ba3-e3d2-46ba-8c1f-ae54c31b9b64/artifacts/0uxld08r_20260113_220229.jpg" }
  ],
  note: "Please check with your private health insurance what is covered and rates. Request additional receipt for your health insurance claim purposes via WhatsApp."
};

export const cancellationPolicy = {
  title: "Cancellation Policy",
  description: "With flexible appointment type you can reschedule or cancel your appointment free of charge, with minimum 24 hour notice prior to your appointment.",
  warning: "Appointments made within 24 hours are automatically subject to cancellation fees. Cancellation fee equals the massage service fee for what you booked."
};
